import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

    svgLoading = '<div class="w-10 h-10"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" xml:space="preserve" viewBox="0 0 40 40"><path opacity=".2" fill="#fff" d="M20.2 5.2a15 15 0 1 0 0 29.9 15 15 0 0 0 0-30zm0 26.5a11.6 11.6 0 1 1 0-23.2 11.6 11.6 0 0 1 0 23.2z"/><path fill="#fff" d="m27.3 11 2-2.7c-2-1.5-4.4-2.6-7-3l-.5 3.3c2 .3 4 1.1 5.5 2.4z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/></path></svg></div>';

    submitButtonLabel;

    static values = {
        /**
         * The post_id of the content item holding the document to be downloaded
         */
        id: Number
    }

    timer;
    width;

    connect() {
        this.submitButtonLabel = this.element.innerHTML;
        this.width = Math.ceil(this.element.offsetWidth);
    }

    setLoadingState() {
        this.element.style.width = `${this.width}px`;
        this.element.setAttribute('disabled', 'disabled');
        this.element.classList.replace("btn-blue", "btn-blue--loading");
        this.element.innerHTML = this.svgLoading;

        this.timer = setInterval(() => {
            this.checkIfFileHasDowloaded()
        }, 500);
    }

    removeLoadingState() {
        this.element.removeAttribute('disabled');
        this.element.classList.replace("btn-blue--loading", "btn-blue");
        this.element.innerHTML = this.submitButtonLabel;
        this.element.style.width = '';
    }

    checkIfFileHasDowloaded() {
        if (this.getCookie(`ekb_download_${this.idValue}`)) {
            clearInterval(this.timer);
            this.removeLoadingState();
            this.deleteCookie(`ekb_download_${this.idValue}`);
        }
    }

    getCookie(name) {
        var b = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : null;
    }

    deleteCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
}
